import { connect } from 'react-redux';
import moment from 'moment';
import ReferralServicesForm from '../../../components/Admin/ReferralServices/ReferralServicesForm';
import {
  createReferralService,
  updateReferralService,
  dismissError,
  getFutureAssignedInstancesForReferralService,
} from '../../../actions/entities/referralServices/index';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';

const mapStateToProps = ({ global: { auth }, entities: { referralServices } }) => {
  const access = auth.featureAccessList;
  return {
    access,
    canEditTreatments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canEditTreatments),
    failureMessage: referralServices.referralService.failure,
  };
};

const mapDispatchToProps = dispatch => ({
  createReferralService: name => dispatch(createReferralService(name)),
  updateReferralService: referralServiceId => dispatch(updateReferralService(referralServiceId)),
  dismissError: () => dispatch(dismissError()),
  validateReferralService: data =>
    dispatch(
      getFutureAssignedInstancesForReferralService(
        data.serviceId,
        moment(data.endDate).format(globals.dateFormats.localApiFormat),
      ),
    ),
});

const ReferralServicesContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReferralServicesForm);

export default ReferralServicesContainer;
